export default defineAppConfig({
    siteTitle: 'HotLot',
})